<template>
    <div  class="alert-ringraziamento-container text-start">
        <div class="alert alert-success" role="alert">
            <div style="margin-bottom: 10px;">{{ intl[$store.state.lang]["thank-you-pt1"] + email +  intl[$store.state.lang]["thank-you-pt2"]}}</div>
        </div>
    </div>
</template>

<script>
import intl from "./intl/intl";

export default {
    name: "alertRingraziamento",
    mounted() {},
    props: {
        email: {
            type: String,
            default: null,
        },
        
    },
    

    data: function () {
        return {
            intl: intl,
            
            
        };
    },
    methods: {
        
    },
    watch: {
        
        
    },
    computed: {
        
    },
};
</script>
